export const apiRoutes = {
  auth: {
    login: "users/login",
    // logout: 'auth/logout',
    me: "v1/users/me",
  },
  handBooks: {
    allHandBooks: (page, limit, text) =>
      `handbooks?page=${page}&limit=${limit}&text=${text}`,
  },
  manualsByModels: {
    allManualsByModels: () => `manuals/by-models`,
  },
  users: {
    allUsers: (page, limit, text) =>
      `users?page=${page}&limit=${limit}&text=${text}`,
    createUser: "users",
    updateUser: (id) => `users/${id}`,
    deleteUser: (id) => `users/${id}`,
    getUser: (id) => `users/${id}`,
    logout: `users/logout`,
  },
  accesses: {
    allAccesses: (page, limit) => `typeManuals?page=${page}&limit=${limit}`,
    createAccess: "typeManuals",
    updateAccess: (id) => `typeManuals/${id}`,
    deleteAccess: (id) => `typeManuals/${id}`,
    getAccess: (id) => `typeManuals/${id}`,
  },
  dealers: {
    allDealersWithoutParams: () => "dealers",
    allDealers: (page, limit, text) =>
      `dealers?page=${page}&limit=${limit}&text=${text}`,
    getDealer: (id) => `dealers/${id}`,
    createDealer: "dealers",
    updateDealer: (id) => `dealers/${id}`,
    deleteDealer: (id) => `dealers/${id}`,
    getOffices: (id) => `dealers/${id}/offices`,
  },
  offices: {
    allOffices: (page, limit, text) =>
      `offices?page=${page}&limit=${limit}&text=${text}`,
    allOfficesWithoutParams: () => "offices",
    getOffice: (id) => `offices/${id}`,
    getOfficeByDealerId: (id) => `offices?dealerId=${id}`,
    createOffice: "offices",
    updateOffice: (id) => `offices/${id}`,
    deleteOffice: (id) => `offices/${id}`,
  },
  profiles: {
    allProfiles: (page, limit) => `profiles?page=${page}&limit=${limit}`,
    createProfile: "profiles",
    updateProfile: (id) => `profiles/${id}`,
    deleteProfile: (id) => `profiles/${id}`,
    getProfile: (id) => `profiles/${id}`,
  },
  newsletters: {
    allNewsletters: (page, limit, text) =>
      `newsletters?page=${page}&limit=${limit}&text=${text}`,
    createNewsletter: "newsletters",
    updateNewsletter: (id) => `newsletters/${id}`,
    deleteNewsletter: (id) => `newsletters/${id}`,
    getNewsletter: (id) => `newsletters/${id}`,
    viewdealer: (page, count, userId) =>
      `newsletters/view-dealer?page=${page}&count=${count}&userId=${userId}`,
  },
  manuals: {
    allManuals: (page, limit, text) =>
      `manuals?page=${page}&limit=${limit}&text=${text}`,
    createManual: "manuals",
    updateManual: (id) => `manuals/${id}`,
    deleteManual: (id) => `manuals/${id}`,
    getManual: (id) => `manuals/${id}`,
    viewdealer: "manuals/view-dealer",
    viewdealervins: "manuals/view-dealer-vins",
    viewdealervinsall: "manuals/view-dealer-vins-all",
  },
  handbooks: {
    createHandbook: "handbooks",
    updateHandbook: (id) => `handbooks/${id}`,
    deleteHandbook: (id) => `handbooks/${id}`,
    allHandBooks: (page, limit, text) =>
      `handbooks?page=${page}&limit=${limit}&text=${text}`,
    getHandbook: (id) => `handbooks/${id}`,
  },
  vins: {
    allVins: (text, page, limit) => `vins?text=${text}&page=${1}&limit=${3000}`,
    allVinsWithoutText: () => `vins?page=${1}&limit=${3000}`,
    createVin: "vins",
    updateVin: (id) => `vins/${id}`,
    deleteVin: (id) => `vins/${id}`,
    getVin: (id) => `vins/${id}`,
    getVinFilter: (text) =>
      `vins/filter/models?page=${1}&limit=${1000}&text=${text}`,
    getVinsModel: `vins/filter/models/year`,
  },
  zones: {
    allZones: `zones`,
  },
  resetpassword: {
    createReset: "resetpassword",
    createResetToken: (tokenId) => `resetpassword/${tokenId}`,
  },
  logdownloads: {
    allLogDownloads: (page, limit) =>
      `logdownloads?page=${page}&limit=${limit}`,
    createLogDownloads: `logdownloads`,
  },
  reports: {
    manualsYear: (year, text) =>
      `handbooks/logdownloads?year=${year}&text=${text}`,
    newslettersYear: (year, text) =>
      `newsletters/logdownloads?year=${year}&text=${text}`,
    logusers: (year, text) => `logusers?year=${year}&text=${text}`,
  },
  adminProfile: {
    userDetail: (id) => `users/${id}`,
  },
  models: {
    allModels: (page, limit, text) =>
      `models?page=${page}&limit=${limit}&text=${text}`,
    createModel: `models`,
    updateModel: (id) => `models/${id}`,
    getModel: (id) => `models/${id}`,
    deleteModel: (id) => `models/${id}`,
  },
  // socialCenter: {
  //   activeUserAttentions: '/attention?closed=false',
  //   closedUserAttentions: '/attention?closed=true',
  //   allUserAttentions: '/attention',
  //   closeAttention: attentionId => `/attention/${attentionId}/end`,
  //   singleAttention: chatId => `attention/${chatId}`,
  //   attentionMessages: attentionId => `/attention/${attentionId}`,
  //   messagesAttentions: (attentionId, order, start, limit) => `/messages/${attentionId}/${order}/${start}/${limit}`,
  //   sendMessageAttention: '/messages/send?messageType=UPDATE',
  //   sendMessageAttentionWithAttachments: '/messages/send-attachment?messageType=UPDATE',
  //   chatReport: accountId => `/attention/account/${accountId}?`,
  //   changeAgentStatus: (userId, state) => `/users/status/agent/${userId}/${state ? 'inactive' : 'active'}`,
  //   transferAttention: (attentionId, userId, newUserId) =>
  //     `/attention/${attentionId}/change_user/${userId}/${newUserId}`,
  //   getShortcuts: topic => `/shortcut/{id}/shortcut?topic=${topic}`,
  //   saveShortcuts: campaign => `/shortcut/${campaign}`,
  //   getShortcutsByCampaing: campaign => `/campaign/shortcut/campaign/${campaign}`,
  //   getCampaignByAccount: accountId => `/campaign/account/${accountId}`,
  // },
  // email: {
  //   loadEmails: 'emails/load',
  //   casesList: 'cases/list',
  //   emailList: 'emails/list',
  //   sendEmail: 'emails/send',
  //   assignCase: 'cases/assign',
  //   caseHistory: 'case/history',
  //   caseHistoryId: id => `case/history/${id}`,
  //   caseReport: 'cases/report',
  //   providers: 'providers/list',
  //   noteList: 'notes/list',
  //   saveNote: 'note/save',
  //   updateCase: 'case/update',
  // },
};
// export const firebaseNodes = {
//   whatsapp: {
//     attentions: 'attentions',
//   },
//   email: {
//     cases: 'cases',
//   },
//   users: {
//     state: 'users-state',
//   },
// };
